import { ArrowRight } from 'lucide-react';
import { EmblaCarouselForReviews } from '~/components/EmblaCarousel';

function Feedback({ name, role, message, isFiveStar = true }) {
    return (
        <div className='flex flex-col overflow-hidden shadow-xl h-full w-full'>
            <div className='flex flex-col justify-between flex-1 p-6 bg-white lg:py-8 lg:px-7'>
                <div className='flex-1'>
                    <div className='flex items-center'>
                        <svg
                            className='w-5 h-5 text-[#FDB241]'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 20 20'
                            fill='currentColor'>
                            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                        </svg>
                        <svg
                            className='w-5 h-5 text-[#FDB241]'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 20 20'
                            fill='currentColor'>
                            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                        </svg>
                        <svg
                            className='w-5 h-5 text-[#FDB241]'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 20 20'
                            fill='currentColor'>
                            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                        </svg>
                        <svg
                            className='w-5 h-5 text-[#FDB241]'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 20 20'
                            fill='currentColor'>
                            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                        </svg>
                        {isFiveStar ? (
                            <svg
                                className='w-5 h-5 text-[#FDB241]'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 20 20'
                                fill='currentColor'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                            </svg>
                        ) : (
                            <svg
                                className='w-5 h-5 text-gray-600'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 20 20'
                                fill='currentColor'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                            </svg>
                        )}
                    </div>

                    <blockquote className='flex-1 mt-8'>
                        <p className='text-lg leading-relaxed text-gray-900 font-pj'>
                            “{message}”
                        </p>
                    </blockquote>
                </div>

                <div className='flex items-center mt-8'>
                    <div className='ml-4'>
                        <p className='text-base font-bold text-gray-900 font-pj'>
                            {name}
                        </p>
                        <p className='mt-0.5 text-sm font-pj text-gray-600'>
                            {role}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function UserReviews() {
    return (
        <section className='py-12 bg-gray-50 sm:py-16 lg:py-20'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='flex flex-col items-center'>
                    <div className='text-center'>
                        <p className='text-lg font-medium text-gray-600 font-pj'>
                            More than 100 people left their five star feedback
                            on how good AI Perfect Assistant
                        </p>
                        <h2 className='mt-4 text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj'>
                            Our happy clients say about us
                        </h2>
                    </div>

                    <div className='mt-8 text-center md:mt-16 md:order-3'>
                        <a
                            href='/reviews'
                            title='Check all 60+ AI Tools'
                            className='inline-flex items-center pb-2 text-base leading-7 text-gray-600 transition-all duration-200  hover:text-gray-900 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 '>
                            Read other reviews on Microsoft App Marketplace{' '}
                            <ArrowRight className='ml-1 h-4' />
                        </a>
                    </div>

                    <div className='relative mt-10 md:mt-18 md:order-2 w-full'>
                        <div className='absolute -inset-x-1 inset-y-16 md:-inset-x-2 md:-inset-y-6'>
                            <div
                                className='w-full h-full max-w-7xl mx-auto rounded-3xl opacity-30 blur-lg filter'
                                style={{
                                    background:
                                        'linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)',
                                }}></div>
                        </div>

                        <div className='max-w-5xl mx-auto'>
                            <EmblaCarouselForReviews
                                slides={[
                                    <Feedback
                                        name='Jin Syoung'
                                        role='Chief Marketing Officer'
                                        message={`We started using the AI
                                                assistant for creative writing
                                                on our team. Having it installed
                                                to my Word document is
                                                incredible. It's always at hand
                                                and the quality of the content
                                                it produces is amazing.`}
                                    />,
                                    <Feedback
                                        name='Lizbeth Gonzalez'
                                        role='Chief Human Resources Officer'
                                        message={`AI Perfect Assistant creates
                                                readable and understandable
                                                pieces of texts. You may just
                                                type in the requirements and all
                                                the work is done! No misprints
                                                or stumbles, love it!`}
                                    />,
                                    <Feedback
                                        name='Kazu Kawasaki'
                                        role='Business Unit Manager'
                                        isFiveStar={false}
                                        message={`Nice addition to my MS Teams
                                                bundle. Quick chat messages,
                                                translations and comment with no
                                                extra effort or brainstorming.`}
                                    />,
                                    <Feedback
                                        name='Yuna Abe'
                                        role='Marketing Director'
                                        message={`Took my rough notes in OneNote and turned them into polished client-ready content in seconds. Impressive!`}
                                    />,
                                    <Feedback
                                        name='Milena Stanković'
                                        role='Executive Manager'
                                        isFiveStar={false}
                                        message={`This tool has fundamentally changed how I write documents. I can take a half-baked draft and turn it into a polished report within minutes. It’s like Grammarly meets ChatGPT - but native to Word.`}
                                    />,
                                    <Feedback
                                        name='Masaru Iwanaga'
                                        role='Human Resources Manager'
                                        message={`Magnificent app! One subscription allows to use it in Excel, PowerPoint, Word and OneNote! I get my notes refined, formulas checked and docs proofread in seconds. Wish I had found it earlier.   `}
                                    />,
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
